import { Flex, Box, Text } from '@chakra-ui/react'
import useTranslation from 'next-translate/useTranslation'
import { Checkbox } from '@ui'
import { ICheckedListingFilterTypes } from '@interfaces'
import { Dispatch } from 'react'

interface ICollectionListingFilterTypes {
  id: string
  labelTx: string
  type: string
}

interface ICollectionFilterByTypeWithCheckbox {
  title?: string
  collectionListingFilterTypes: ICollectionListingFilterTypes[]
  setCheckedListingFilterTypes: Dispatch<ICheckedListingFilterTypes[]>
  checkedListingFilterTypes: ICheckedListingFilterTypes[]
  inline?: boolean
}

const CollectionFilterByTypeWithCheckbox = ({
  title,
  collectionListingFilterTypes,
  checkedListingFilterTypes,
  setCheckedListingFilterTypes,
  inline = false,
}: ICollectionFilterByTypeWithCheckbox) => {
  const { t } = useTranslation()

  const handleOnChange = (checkedValue: boolean, index: number) => {
    const cloneOldCheckedList = [...checkedListingFilterTypes]
    cloneOldCheckedList[index] = checkedValue
    setCheckedListingFilterTypes(cloneOldCheckedList)
  }

  return (
    <Box px="padding.primary" py="5">
      {title ? (
        <Text fontWeight="medium" fontSize="sm" mb="6px">
          {title}
        </Text>
      ) : null}
      <Flex
        flexDirection={inline ? 'row' : 'column'}
        flexWrap="nowrap"
        overflowX={inline ? 'auto' : 'visible'}
        overflowY="hidden"
        pb={inline ? { base: 3, lg: 1 } : 0}
        sx={{
          ...(inline
            ? {
                '&::-webkit-scrollbar': {
                  height: '3px',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'white.primary3',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: 'red.primary',
                },
                '& > *': {
                  flexShrink: 0,
                  whiteSpace: 'nowrap',
                },
              }
            : {}),
          '&>*+*': inline
            ? {
                marginLeft: '20px',
                marginTop: 0,
              }
            : {
                marginTop: '10px',
              },
        }}
      >
        {collectionListingFilterTypes.map((row, index) => (
          <Checkbox
            key={row.id}
            fontFamily="duruSans"
            isChecked={checkedListingFilterTypes[index]}
            onChange={(e) => handleOnChange(e.target.checked, index)}
          >
            {t(row.labelTx)}
          </Checkbox>
        ))}
      </Flex>
    </Box>
  )
}

export default CollectionFilterByTypeWithCheckbox
